import React, {useState} from "react";
import Pages from "./components/pages/Pages";
import LanguageRedirector from "./components/LanguageRedirector/LanguageRedirector";
import LangModal from "./components/LangModal/LangModal";
import './App.css';
import { useLocation,useNavigate } from "react-router-dom";

// Added Pop Up for language, Moved Cookie Consent to Pop Up, Removed Login Page and Added language redirector code

function App() {
  const [userPrefs, setUserPrefs] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();
  const handlePrefsSubmit = (prefs) => {
    setUserPrefs(prefs);
    navigate(location.pathname, { replace: true });
  };

  return (
    <>
      {!userPrefs && <LangModal onSubmit={handlePrefsSubmit} />}
      {<LanguageRedirector />}
      <Pages />
    </>
  );
}

export default App;
